
import { Vue, Component, Prop } from 'vue-property-decorator';
import { Form, FormItem, Cascader } from 'element-ui';
import api from '@/api/asset';
import quesApi from '@/api/question';
import Util from '@/libs/util';
import Button from '@/components/Button/tButton.vue';
import { ITButton } from '@/components/Button/index.d';

@Component({
  components: {
    Form,
    FormItem,
    Cascader,
    Button,
  },
})
export default class AllotForm extends Vue {
  @Prop() datas: any;

  private subBtn: ITButton = {
    title: '确 定',
    type: 'primary',
    icon: '',
    callback: () => this.handleSubmit(),
  };

  private form: { tid: Array<string>, cid: Array<string> } = {
    tid: [],
    cid: [],
  };

  private rules: { [key: string]: Array<object> } = {
    tid: [
      { required: true, message: '课程类型不可为空', trigger: 'blur' },
    ],
    cid: [
      { required: true, message: '课程章节不可为空', trigger: 'blur' },
    ],
  };

  private options: { [key: string]: Array<object> } = { tidOpts: [], cidOpts: [] };

  private refresh: { [key: string]: boolean } = { tidRef: false, cidRef: false };

  private loading: { [key: string]: boolean } = { modal: false, submit: false };

  public $ref!: {
    form: Form,
  };

  created() {
    this.getCourseType();
  }

  // 获取
  getCourseType() {
    return quesApi.getCourseType().then((res: any) => {
      this.options.tidOpts = Util.CompTreeNode(res, 'children');
      return true;
    });
  }

  getCourseByType(tid: string) {
    return quesApi.getCourseByType(tid).then((res: any) => {
      this.options.cidOpts = res.map((em: any) => ({ id: em.id, children: em.chapters, name: `${em.name} ${em.version ? em.version : ''}` }));
      return true;
    });
  }

  // 处理课程类型刷新
  handleTidOptsRefresh() {
    this.refresh.tidRef = true;
    this.options.tidOpts = [];
    this.getCourseType().then((result: any) => {
      if (result) {
        this.msg('获取课程类型成功 ~', 'success');
        this.refresh.tidRef = false;
      }
    /* eslint-disable no-return-assign */
    }).catch(() => this.refresh.tidRef = false);
  }

  // 处理课程章节刷新
  handleCidOptsRefresh() {
    if (this.form.tid.length === 0) this.msg('请先选择课程类型鸭 ~', 'warning');
    else {
      this.refresh.cidRef = true;
      this.options.cidOpts = [];
      this.getCourseByType(this.form.tid[1]).then((result: any) => {
        if (result) {
          this.msg('获取课程章节成功 ~', 'success');
          this.refresh.cidRef = false;
        }
      /* eslint-disable no-return-assign */
      }).catch(() => this.refresh.cidRef = false);
    }
  }

  // 处理课程章节的改变
  handleTidChange(v: Array<any>) {
    if (v.length > 0) {
      (this.$refs.form as Form).clearValidate();
      this.getCourseByType(v[1]);
    } else {
      this.options.cidOpts = [];
      this.form.tid = [];
      this.form.cid = [];
    }
  }

  handleSubmit() {
    this.loading.sumbit = true;
    this.loading.modal = true;
    (this.$refs.form as Form).validate((valid: boolean) => {
      if (valid) {
        const mids: Array<string> = [];
        Object.values(this.datas).forEach((em: any) => mids.push(...em));
        this.loading.sumbit = false;
        api.createChapterAsset({ cid: this.form.cid[1] || '', mids: mids.join(',') }).then((res: any) => {
          this.$emit('close');
          (this.$refs.form as Form).resetFields();
          this.loading.sumbit = false;
          this.loading.modal = false;
        }).catch(() => {
          this.loading.sumbit = false;
          this.loading.modal = false;
        });
      } else {
        this.loading.sumbit = false;
        this.loading.modal = false;
      }
    });
  }
}
